import ButtonField from '@/components/form-control/ButtonField'
import { useTranslation } from '@/hooks/useTranslation'
import { DATA_TABLE_PIPE } from '@/constant/common'
import { Stack, Typography } from '@mui/material'
import FooterSetup from '../../common/FooterSetup'
import MenuHeader from '../../common/MenuHeader'
import RightGoogleMapSmall from '../../common/RightGoogleMapSmall'
import SetUpLayout from '../../common/SetUpLayout'
import PipesTable from './PipesTable'

type Props = {}

const EmitterData = (props: Props) => {
  const { t } = useTranslation()

  const handleClick = () => {

  }

  return (
    <SetUpLayout
      title='Pipes'

      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMapSmall />}
      footer={<Stack p="25px 32px"><FooterSetup /></Stack>}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography sx={{ fontSize: "20px", lineHeight: "2.4" }}>{t('commonLabelsReviewPipeData')}</Typography>
        <Stack alignItems="center">
          <ButtonField
            startIcon={<></>}
            style={{
              height: '32px',
              minWidth: '89px',
              borderRadius: '5px',
            }}
            name="Done"
            onClick={handleClick}
          />
        </Stack>
      </Stack>
      <PipesTable rows={DATA_TABLE_PIPE} />
    </SetUpLayout>
  )
}

export default EmitterData